// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"5a6173e2c367b5b4c5ec","655":"a31fb2448657cb115403"}[chunkId] + ".js";
};